export interface IConextosCreceMas {
    log_out: ContextosUrl,
    share_content: ContextosUrl,
    text_copy: ContextosUrl,
    email_share: ContextosUrl
}

export interface IContextosPremiados {
    share_content: ContextosUrl
}

interface ContextosUrl {
    [key: string]: string
}

export const DConextosCreceMas: IConextosCreceMas = {
    log_out: {
        context_logout: '/logoutgp',
    },
    share_content: {
        context_combo: '/final/image/local',
        context_whatsapp_design: '/final/original',
        context_materials: '/download/mat/',
        context_whatsapp: '/api/whatsapp/get/final/original',
        context_posterbuilder: '/api/final/image/local/download/original',
        context_qrcode: '/generate/qr/img',
        context_stickers: 'dashboardo/materiales'
    },
    text_copy: {
        context_textqrcode: '/share/qr'
    },
    email_share: {
        context_emailqr: 'mailto'
    }
}

export const DContextosPremiados: any = {
    share_content: {
        instructions_pdf: 'instrucciones.pdf'
    }
}
